import { render, staticRenderFns } from "./API.vue?vue&type=template&id=4bbebb18&"
import script from "./API.vue?vue&type=script&lang=js&"
export * from "./API.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports